import { useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import { ContextProps, Country } from "@menu/core/types";
import { getAnalyticTags, AnalyticsType } from "@menu/core/lib";
import useSelector from "./use-selector";

type CountrySelectorProps = ContextProps & {
    showFlag?: boolean,
    open?: boolean,
    isMobile?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => { }

const CountrySelector = observer((props: CountrySelectorProps) => {
    const { context, showFlag = false, open = false, isMobile = false } = props;
    const selectRef = useRef<any>(null);
    const { toggleIsOpen, cssClassName } = useSelector(selectRef, isMobile);

    const countryData = context.countries;

    const selectCountry = (selectedItem: Country) => {
        const newCulture = selectedItem?.languages && selectedItem.languages.length > 1
            ? selectedItem.languages[0]
            : undefined;

        context.updateCulture(newCulture);
        context.updateCountry(selectedItem);

        window.location.href = selectedItem.url ?? "/";
    }

    useEffect(() => {
        if (open && selectRef.current) {
            toggleIsOpen({
                forceOpen: true,
                preventDefault: noop,
                stopPropagation: noop
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, selectRef]);

    if (!selectCountry) {
        return null;
    }

    const country = context?.country;

    if (!country) {
        return null;
    }

    const analytics = getAnalyticTags({
        component_name: "region_switcher",
        nav_item: AnalyticsType.culture,
        nav_text: country.title.toLowerUnderscoreCase(),
        target_page_url: `/${country.culture}/`
    });

    return (<span ref={selectRef} className={cssClassName}>
        <span className="select-container"
            onClick={toggleIsOpen}
            {...analytics}>

            {showFlag && <img src={country?.flagImage} className="flag" title={country.title} />}

            <span>
                {country.title}
            </span>

            <i className="icon-arrow-down_4px"></i>
        </span>
        <div>
            <ul>
                {countryData.map((country, index) => (
                    <li onClick={(e) => selectCountry(country)}
                        key={index}>
                        {country.title}
                    </li>
                ))}
            </ul>
        </div>
    </span>);
});

export default CountrySelector;